import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '@charlesschwab/as-ui-core';
import { AuthenticationService, CoreService } from '@charlesschwab/sac-ui-core';
import { FeatureToggleConfigurationProperties } from '@schwab/schwab-feature-toggle-angular';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private readonly authService: AuthenticationService, private coreService: CoreService, private cookieService: CookieService) {
  }

  initializeApp(): Promise<void> {
    this.cookieService.createCookie('containerCurrentTab', 'moneymovement', 0);

    return new Promise<void>((resolve) => {

      if (this.authService.externalAccessToken) {
        resolve();
        return;
      }

      this.authService.authenticate().subscribe(() => {
        resolve();
      }, (error) => {
        console.log('Unable to authenticate to initialize the app', error);
      });
    });
  }


  setClientSideId(): FeatureToggleConfigurationProperties {
    let launchDarklyClientSideId = '';

    switch (this.coreService.environment) {
      case 'DEV':
      case 'SIT01':
        // this is the Development environment in Launch Darkly
        launchDarklyClientSideId = '62cc57432cd88e10e3196fe9';
        break;
      case 'TB':
      case 'TY':
      case 'PVS':
      case 'QA':
      case 'QAE01':
      case 'PTE01':
        // this is the Test environment in Launch Darkly - it is meant for QA.
        // If we create a new environment for the ones above this, add them there.
        launchDarklyClientSideId = '62cc57244531ff1148752627';
        break;
      case 'EIS':
      case 'PRE01':
      case 'UAT':
      case 'PROD':
        // this is the Production environment in Launch Darkly
        launchDarklyClientSideId = '62cc57244531ff1148752628';
        break;
      default:
        launchDarklyClientSideId = '';
        console.log(`Feature flags failed to load.`)
        break;
    }


    const launchDarklyEnvConfig: FeatureToggleConfigurationProperties = {
      clientSideId: launchDarklyClientSideId,
    }

    return launchDarklyEnvConfig;
  }
}
